// extracted by mini-css-extract-plugin
export const wrapper = "promo-module-bottom-module--wrapper--2A0sI";
export const headline = "promo-module-bottom-module--headline--J-Hpo";
export const body = "promo-module-bottom-module--body--2_OUn";
export const content = "promo-module-bottom-module--content--eWRL1";
export const image = "promo-module-bottom-module--image--1FKAv";